import { Data } from '../signup-data/DATA';
import { setSignupDataValue } from '../store/signup-data/action-creators';
import { generateDevelopersDomainFromEmail } from '../utils/generateDummyDomainFromEmail';
export const prefillCompanyDomainFromEmail = email => dispatch => {
  const generatedDomain = generateDevelopersDomainFromEmail(email);
  dispatch(setSignupDataValue(Data.CompanyDomain, generatedDomain));
};